import { render, staticRenderFns } from "./CourtOrderRspToLeaveGrantedPg.vue?vue&type=template&id=05aefd4d&scoped=true"
import script from "./CourtOrderRspToLeaveGrantedPg.vue?vue&type=script&lang=ts"
export * from "./CourtOrderRspToLeaveGrantedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aefd4d",
  null
  
)

export default component.exports